import BaseComponent from "@js/components/base_component.jsx";

import EuiLinkReplacementsForm from "@js/components/eui/link_replacements/form.jsx";

class EuiLinkReplacementsShow extends BaseComponent {

  render() {
    return (
      <EuiLinkReplacementsForm { ...this.props } editing={ false } />
    );
  }

}

export default EuiLinkReplacementsShow;
